/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBillingDetails200ResponseCard
 */
export interface GetBillingDetails200ResponseCard {
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200ResponseCard
     */
    brand: string;
    /**
     * 
     * @type {string}
     * @memberof GetBillingDetails200ResponseCard
     */
    lastDigits: string;
}

/**
 * Check if a given object implements the GetBillingDetails200ResponseCard interface.
 */
export function instanceOfGetBillingDetails200ResponseCard(value: object): value is GetBillingDetails200ResponseCard {
    if (!('brand' in value) || value['brand'] === undefined) return false;
    if (!('lastDigits' in value) || value['lastDigits'] === undefined) return false;
    return true;
}

export function GetBillingDetails200ResponseCardFromJSON(json: any): GetBillingDetails200ResponseCard {
    return GetBillingDetails200ResponseCardFromJSONTyped(json, false);
}

export function GetBillingDetails200ResponseCardFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingDetails200ResponseCard {
    if (json == null) {
        return json;
    }
    return {
        
        'brand': json['brand'],
        'lastDigits': json['lastDigits'],
    };
}

export function GetBillingDetails200ResponseCardToJSON(json: any): GetBillingDetails200ResponseCard {
    return GetBillingDetails200ResponseCardToJSONTyped(json, false);
}

export function GetBillingDetails200ResponseCardToJSONTyped(value?: GetBillingDetails200ResponseCard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brand': value['brand'],
        'lastDigits': value['lastDigits'],
    };
}

